import { Box } from '@mui/system';
import {
	DataGrid,
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarExport,
	GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { usePapaParse } from 'react-papaparse';

const SummaryDataGrid = (props) => {
	const [data, setData] = useState([]);

	const csv = props.csv;
	const filter = props.filter;
	const { readString } = usePapaParse();

	const handleReadString = () => {
		readString(csv, {
			complete: (results) => {
				// Log the parsed CSV results
				console.log('Parsed Results:', results);

				results.data.forEach((d, idx) => {
					d.id = idx; // Add unique ID for DataGrid
				});

				// Log data object keys
				if (results.data.length > 0) {
					console.log('Data Object Keys:', Object.keys(results.data[0]));
				}

				// Filter data by column 'Food commodity'
				const filteredData = results.data.filter(
					(d) => d['Food commodity'] === filter
				);
				console.log('Filtered Data:', filteredData);

				setData(filteredData);
			},
			download: true,
			header: true,
			dynamicTyping: true,
			error: (error) => {
				console.error('Parsing Error:', error);
			},
		});
	};

	useEffect(() => {
		handleReadString();
	}, [filter]);

	const cols = [
		{ field: 'Pesticide', headerName: 'Pesticide', flex: 1, minWidth: 100 },
		{ field: 'Auth', headerName: 'Authorisation status', flex: 1, minWidth: 100 },
		{
			field: 'Total number of results',
			headerName: 'Total no. of results',
			type: 'number',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'Flag. Above Legal Limit result ID_sum',
			headerName: 'MRL exceedances',
			type: 'number',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'Flag. non Compliant PEST result ID_sum',
			headerName: 'Non-compliant',
			type: 'number',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'Number of countries',
			headerName: 'Countries analysed',
			type: 'number',
			flex: 1,
			minWidth: 100,
		},
		{ field: 'Coverage', headerName: 'Coverage', flex: 1, minWidth: 100 },
	];

	function CustomToolbar() {
		return (
			<GridToolbarContainer>
				<GridToolbarColumnsButton sx={{ color: '#1F2442' }} />
				<GridToolbarFilterButton sx={{ color: '#1F2442' }} />
				<GridToolbarDensitySelector sx={{ color: '#1F2442' }} />
				<GridToolbarExport sx={{ color: '#1F2442' }} />
			</GridToolbarContainer>
		);
	}

	return (
		<Box sx={{ height: 350, marginBottom: '4rem' }}>
			<p style={{ marginBottom: '.5rem' }}>{props.title}</p>
			<DataGrid
				columns={cols}
				rows={data}
				components={{ Toolbar: CustomToolbar }}
			/>
		</Box>
	);
};

export default SummaryDataGrid;
